module.exports = __webpack_public_path__ + "img/typing.9d328425.svg";